import { FC, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useAuthContext } from "src/components/context/auth"
import { adminLoginService } from "src/domain/services/admin/adminLoginService"
import { FormikOnSubmit } from "src/utils/types"
import { ILoginFormFields, LoginFormView } from "."

export const LoginFormContainer: FC = () => {
	const { setToken } = useAuthContext()
	const navigate = useNavigate()

	const handleSubmit = useCallback<FormikOnSubmit<ILoginFormFields>>(
		async (values, { setErrors }) => {
			try {
				const { token } = await adminLoginService(values)
				setToken(token)

				navigate("/")
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ password: message })
			}
		},
		[navigate, setToken],
	)

	return <LoginFormView handleSubmit={handleSubmit} />
}
